import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(list)/component-variants',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/my-components/component-variants' ||
      location.pathname === '/my-components/component-variants/'
    ) {
      throw redirect({ to: '/my-components/component-variants/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/ComponentVariantsLayout'),
    'ComponentVariantsLayout',
  ),
});
